import { createSlice } from '@reduxjs/toolkit';

const sliceFlags = createSlice({
  name: 'checklistStudentIndex',
  initialState: {
    indexCarusel: 0,
    indexAcardionItem: null,
  },
  reducers: {
    setIndexCarusel(state, action) {
      state.indexCarusel = action.payload;
    },
    setIndexAcardionItem(state, action) {
      state.indexAcardionItem = action.payload;
    },
  },
});

export const { setIndexCarusel, setIndexAcardionItem } = sliceFlags.actions;

export const getIndexCarusel = state => state.checklistStudentIndex.indexCarusel;
export const getIndexAcardionItem = state => state.checklistStudentIndex.indexAcardionItem;

export default sliceFlags.reducer;
